import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-token-expired',
  standalone: false,
  templateUrl: './verification-link-expired.html'
})
export class TokenExpiredComponent {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/auth/login']);
  }
}
